import { render, staticRenderFns } from "./number-value.vue?vue&type=template&id=352521c6&scoped=true&"
import script from "./number-value.vue?vue&type=script&lang=js&"
export * from "./number-value.vue?vue&type=script&lang=js&"
import style0 from "./number-value.vue?vue&type=style&index=0&id=352521c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352521c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352521c6')) {
      api.createRecord('352521c6', component.options)
    } else {
      api.reload('352521c6', component.options)
    }
    module.hot.accept("./number-value.vue?vue&type=template&id=352521c6&scoped=true&", function () {
      api.rerender('352521c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/number-value.vue"
export default component.exports